import Wrapper from 'components/layouts/Main';
import ModalAdd from 'components/layouts/modal/AddBoard';
import Loader from 'components/layouts/modal/Loader';
import PopUp from 'components/layouts/modal/PopUp';
import { Hooks } from 'providers';
import React, { useCallback, useContext } from 'react';
import { useSelector } from 'react-redux';
import {
  Redirect, Route, RouteComponentProps, useLocation,
} from 'react-router-dom';
// organization

import ModalUpdateStructureNode from 'components/organizations/structure-view/ModalFormUpdate';
// employee
import ModalUpdateEmployeeNode from 'components/organizations/employees/ModalFormUpdate';
import { Matrix } from 'providers/Matrix';
import { Organization } from 'providers/Organization';

import Error504 from 'components/layouts/504';
import Maintenance from 'components/layouts/maintenance';
import ModalConflict from 'components/matrix/modal/ConflictData';
import ModalAssessment from 'components/workloadAssessment/analytics/parts/PopUpAssessment';

type LoggedProps = {
  readonly component: React.ElementType;
  readonly header?: boolean;
  readonly matrix?: boolean;
  readonly path: string;
  readonly exact?: boolean;
  readonly loginType?: string;
  readonly isFeatureListed?: boolean;
  readonly bo?: boolean;
  readonly [key: string]: unknown;
};

interface LoggedRootState {
  readonly loading?: {
    readonly loading?: boolean;
  };
}

type ModalSetter = (value: boolean) => void;

type MatrixContextValue = {
  readonly modalAudit?: boolean;
  readonly modalConflict?: boolean;
  readonly modalSummary?: boolean;
  readonly setModalAudit: ModalSetter;
  readonly setModalSummary: ModalSetter;
  readonly setModalConflict: ModalSetter;
};

type HooksContextValue = {
  readonly modal?: boolean;
  readonly modalAdd?: boolean;
  readonly modalAssessment?: boolean;
  readonly modalDelete?: boolean;
  readonly setModal: ModalSetter;
  readonly setModalDelete: ModalSetter;
  readonly setModalAdd: ModalSetter;
  readonly setModalAssessment: ModalSetter;
};

type OrganizationContextValue = {
  readonly employeeModal?: boolean;
  readonly modal?: boolean;
  readonly modalAddEmployee?: boolean;
  readonly modalUpdate?: boolean;
  readonly setModal: ModalSetter;
  readonly setModalUpdate: ModalSetter;
  readonly setEmployeeModal: ModalSetter;
  readonly setModalAddEmployee: ModalSetter;
};

function Logged({
  component: Component, header = false, matrix: routeMatrix = false, ...rest
}: LoggedProps) {
  void routeMatrix;
  const {
    modalAudit, modalConflict, modalSummary, setModalAudit, setModalSummary, setModalConflict,
  } = useContext(Matrix) as MatrixContextValue;
  const {
    modal, modalAdd, modalAssessment, modalDelete, setModal, setModalDelete, setModalAdd, setModalAssessment,
  } = useContext(Hooks) as HooksContextValue;
  const {
    employeeModal,
    modal: organizationModal,
    modalAddEmployee,
    modalUpdate,
    setModal: setOrganizationModal,
    setModalUpdate,
    setEmployeeModal,
    setModalAddEmployee,
  } = useContext(Organization) as OrganizationContextValue;
  const { loading } = useSelector((state: LoggedRootState) => ({
    loading: state.loading?.loading,
  }));
  const location = useLocation();
  const hasOpenModal = Boolean(
    modal
      || modalAdd
      || modalAssessment
      || modalAudit
      || modalConflict
      || modalDelete
      || modalSummary
      || organizationModal
      || modalAddEmployee
      || modalUpdate
      || employeeModal,
  );

  const closeAll = useCallback(() => {
    setModalAudit(false);
    setModalSummary(false);
    setEmployeeModal(false);
    setModalAddEmployee(false);
    setModal(false);
    setModalUpdate(false);
    setOrganizationModal(false);
    setModalDelete(false);
    setModalAdd(false);
    setModalConflict(false);
    setModalAssessment(false);
  }, [
    setEmployeeModal,
    setModal,
    setOrganizationModal,
    setModalAdd,
    setModalAddEmployee,
    setModalAssessment,
    setModalAudit,
    setModalConflict,
    setModalDelete,
    setModalSummary,
    setModalUpdate,
  ]);

  const token = localStorage.getItem('token');
  if (
    ((process.env.REACT_APP_LIST_MAINTENANCE.length > 0
    && process.env.REACT_APP_LIST_MAINTENANCE.split(', ').includes(rest.path)) || process.env.REACT_APP_MAINTENANCE_IS_ACTIVE === 'true')
  ) {
    return (
      <Route
        {...rest}
        render={() => <Maintenance />}
      />
    );
  }
  if (token === null) {
    const role = localStorage.getItem('history');
    if (role === 'admin') {
      return <Redirect to="/administrator" />;
    }
    return <Redirect to="/signin" />;
  }
  if (rest.isFeatureListed !== undefined && !rest.isFeatureListed) {
    return <Error504 />;
  }
  return (
    <Route
      {...rest}
      location={location}
      render={(props: RouteComponentProps) => (
        <>
          {loading && <Loader />}
          {header ? (
            <Wrapper {...rest}>
              <Component {...props} />
            </Wrapper>
          ) : (
            <Component {...props} />
          )}

          <PopUp />
          <ModalAdd />
          <ModalUpdateStructureNode title="Edit Structure Node" />
          <ModalUpdateEmployeeNode title="Edit Employee Node" />
          <ModalAssessment />
          <ModalConflict />
          {hasOpenModal && (
            <button
              type="button"
              onClick={closeAll}
              aria-label="Close modal backdrop"
              className="modal-backdrop fade show"
              style={{
                border: 0,
                padding: 0,
                transition: 'all 0.5s ease',
              }}
            />
          )}
        </>
      )}
    />
  );
}

export default Logged;
